<template>
  <AutoComplete
    v-model="realValue"
    :clearable="clearable"
    :disabled="disabled"
    :placeholder="placeholder === '' ? $t('companies.search') : placeholder"
    :size="size"
    :icon="icon"
    :placement="placement"
    :transfer="transfer"
    @on-search="realHandleInput"
    @on-select="handleSelect">
    <div v-if="loading || typing" id="loading">{{ $t('companies.searching') }}</div>
    <div v-if="!loading && !typing && options.length === 0 && value !== ''" id="no-result">{{ $t('companies.no_result') }}</div>
    <Option
      v-if="!loading && !typing && options.length > 0"
      v-for="item in options"
      :key="item.id"
      :value="item.name">{{ item.name }}</Option>
  </AutoComplete>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'selectCompany',
  data () {
    return {
      options: [],
      loading: false,
      latestRequest: -1,
      typing: false,
      debouncedHandleInput: null,
      handlingSelect: false,
      realValue: this.value,
      cache: []
    }
  },
  props: {
    value: {
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'default'
    },
    icon: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'bottom-start'
    },
    transfer: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value () {
      this.realValue = this.value === undefined ? '' : this.value
    },
    realValue () {
      this.$emit('input', this.realValue)
      // this.$emit('update:value', this.realValue)
    }
  },
  mounted () {
    this.debouncedHandleInput = _.debounce(this.handleInput, 300)
    this.cache = []
  },
  methods: {
    ...mapActions([
      'getPagedCompanies'
    ]),
    realHandleInput (keyword) {
      if (!this.handlingSelect) {
        if (this.debouncedHandleInput !== null) {
          this.typing = true
          let cacheFlag = false
          for (let item of this.cache) {
            if (item.input === keyword) {
              this.options = item.result
              cacheFlag = true
              this.typing = false
              break
            }
          }
          if (!cacheFlag) {
            this.debouncedHandleInput(keyword)
          }
        } else {
          this.options = []
        }
      }
    },
    handleInput (keyword) {
      const timeStamp = new Date().getTime()
      this.latestRequest = timeStamp
      this.loading = true
      this.typing = false
      this.getPagedCompanies({
        page: 1,
        limit: 10,
        query: keyword,
        tags: null
      }).then(res => {
        if (timeStamp === this.latestRequest) {
          let returnList = []
          for (let company of res.data) {
            returnList.push(company)
          }
          this.loading = false
          this.options = returnList
          this.cache.push({
            input: keyword,
            result: returnList
          })
        }
      })
    },
    handleSelect (keyword) {
      this.handlingSelect = true
      for (let item of this.options) {
        if (item.name === keyword) {
          this.$emit('on-select', item)
          break
        }
      }
      this.$nextTick(() => {
        this.handlingSelect = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
#loading, #no-result {
  width: 100%;
  text-align: center;
  padding: 10px 0;
  opacity: .5;
}
</style>
